import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import MainLayout from './routes/main_layout';
import Login from './routes/login';
import Register from "./routes/register";
import Landing from "./routes/landing";
import About from "./routes/about";
import FAQ from "./routes/faq";
import RecoverPassword from "./routes/recoverPassword";
import TermsAndConditions from "./routes/terms_conditions";

import { GTMProvider } from '@elgorditosalsero/react-gtm-hook'

const App = () => {
  const gtmParams = { id: 'GTM-M9F7NNF' }

  return (
    <GTMProvider state={gtmParams}>
      <Router>
          <Switch>
            <Route exact path="/login">
              <Login />
            </Route>
            <Route exact path="/login/:giftId">
              <Login />
            </Route>
            <Route exact path="/register">
              <Register />
            </Route>
            <Route exact path="/register/:giftId">
              <Register />
            </Route>
            <Route exact path="/recover_password">
              <RecoverPassword />
            </Route>
            <Route exact path="/">
              <Landing />
            </Route>
            <Route exact path="/terms_and_conditions">
              <TermsAndConditions />
            </Route>
            <Route exact path="/about">
              <About/>
            </Route>
            <Route exact path="/faq">
              <FAQ />
            </Route>
            <Route>
              <MainLayout />
            </Route>
          </Switch>
      </Router>
    </GTMProvider>
  );
}

export default App;
